import { action, observable } from "mobx";
import moment from "moment";
import NestStore from "~/stores/NestStore";
import Immersive3dTourExportUrlRepository from "~/repository/Immersive3dTour/Immersive3dTourExportUrlRepository";

class Immersive3dTourExportUrlStore extends NestStore {
  /**
   * @property {number|null}
   */
  tourId = null;

  /**
   * @property {string|null}
   */
  @observable immersive3dTourExportUrl = null;

  /**
   * @property {string|null}
   */
  token = null;

  immersive3dTourExportUrlRepository = null;

  constructor() {
    super();

    this.immersive3dTourExportUrlRepository = new Immersive3dTourExportUrlRepository();
  }

  @action
  update() {
    this.isLoading = true;

    const data = {};

    let query = null;

    if (this.token) {
      query = { token: this.token };
    }

    return this.immersive3dTourExportUrlRepository
      .update(this.tourId, data, query)
      .then(response => {
        this.immersive3dTourExportUrl = response.data.immersive3dTourExportUrl;
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  hasExportUrlExpired(exportUrl) {
    if (!exportUrl) {
      return false;
    }

    const url = new URL(exportUrl);

    return moment.unix(Number(url.searchParams.get("Expires"))) <= moment();
  }
}

export default Immersive3dTourExportUrlStore;
